module.exports = __webpack_public_path__ + "img/amazon_logo@2x.7ff3fd24.png";